module.exports = __webpack_public_path__ + "static/media/timesheet_Details.c91d6e05.png";